import { createAction } from "@reduxjs/toolkit";

const signOut = createAction<void>("main/signOut");

export { signOut };
